<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-toolbar>
          <v-toolbar-title style="margin-right:5px">Slide Manager</v-toolbar-title>
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text>
                <v-icon left>fas fa-caret-down</v-icon>
                {{ label }}
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="(section, index) in sectionList" :key="'section-' + index" :disabled="section.label === label || !(isAdmin || inArray(user.username, section.editors))" :to="'/admin/slides/' + section.code">
                <v-list-item-title>{{ section.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="addSlide">
            <v-icon left>fal fa-plus</v-icon>
            Add Slide
          </v-btn>
        </v-toolbar>
        <v-expansion-panels v-model="activeSlide">
          <v-expansion-panel v-for="(slide, index) in slides" :key="'slide-' + index">
            <v-expansion-panel-header>{{ slide.name || 'Slide ' + (index + 1) }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="slide.name" label="Name of slide (for navigation menu)" hide-details @change="(name) => updateSlide(index, name)"></v-text-field>
                </v-col>
                <v-col cols="6" md="6">
                  <v-list dense>
                    <v-subheader>Primary Column</v-subheader>
                    <v-list-item v-for="(block, blockIndex) in slide.primary" :key="'slide-' + index + '-primary-' + blockIndex">
                      <v-list-item-avatar style="margin:0 16px 0 0">
                        <v-icon>{{ blockIcon(block.type) }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ block.name || block.type.split(/(?=[A-Z])/).join(' ') }}</v-list-item-title>
                        <v-list-item-subtitle v-if="block.name">{{ block.type.split(/(?=[A-Z])/).join(' ') }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <content-editor
                          :id="block.id"
                          :is-first="blockIndex === 0"
                          :is-last="blockIndex === slide.primary.length - 1"
                          :in-primary="true"
                          :small-button="true"
                          @change="(block) => updateBlock(index, 'primary', blockIndex, block)"
                          @remove="removeBlock(index, 'primary', blockIndex)"
                          @moveUp="moveBlock(index, 'primary', blockIndex, -1)"
                          @moveDown="moveBlock(index, 'primary', blockIndex, 1)"
                          @moveRight="changeColumns(index, 'primary', blockIndex)"></content-editor>
                      </v-list-item-action>
                    </v-list-item>
                    <!-- <v-list-item style="border:1px solid #CCC" @click="addBlock(index, 'primary')">
                      <v-list-item-avatar>
                        <v-icon>fas fa-plus</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-title>Add Block</v-list-item-title>
                    </v-list-item> -->
                  </v-list>
                  <v-btn @click="addBlock(index, 'primary')">
                    <v-icon left small>fal fa-plus</v-icon>
                    Add Block
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                  <v-list dense>
                    <v-subheader>Secondary Column</v-subheader>
                    <v-list-item v-if="slide.secondary.length === 0">
                      <v-list-item-content>
                        <v-list-item-title>No Secondary Column</v-list-item-title>
                        <v-list-item-subtitle style="white-space:normal;">There are currently no data blocks in the secondary column, so all content in the primary column will be displayed in the center with no second column. To change this, add a content block here (or move one from the primary column).</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(block, blockIndex) in slide.secondary" :key="'slide-' + index + '-secondary-' + blockIndex">
                      <v-list-item-avatar style="margin:0 16px 0 0">
                        <v-icon>{{ blockIcon(block.type) }}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ block.name || block.type.split(/(?=[A-Z])/).join(' ') }}</v-list-item-title>
                        <v-list-item-subtitle v-if="block.name">{{ block.type.split(/(?=[A-Z])/).join(' ') }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <content-editor
                          :id="block.id"
                          :is-first="blockIndex === 0"
                          :is-last="blockIndex === slide.secondary.length - 1"
                          :in-primary="false"
                          :small-button="true"
                          @change="(block) => updateBlock(index, 'secondary', blockIndex, block)"
                          @remove="removeBlock(index, 'secondary', blockIndex)"
                          @moveUp="moveBlock(index, 'secondary', blockIndex, -1)"
                          @moveDown="moveBlock(index, 'secondary', blockIndex, 1)"
                          @moveLeft="changeColumns(index, 'secondary', blockIndex)"></content-editor>
                      </v-list-item-action>
                    </v-list-item>
                    <!-- <v-list-item style="border:1px solid #CCC" @click="addBlock(index, 'secondary')">
                      <v-list-item-avatar>
                        <v-icon>fas fa-plus</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-title>Add Block</v-list-item-title>
                    </v-list-item> -->
                  </v-list>
                  <v-btn @click="addBlock(index, 'secondary')">
                    <v-icon left small>fal fa-plus</v-icon>
                    Add Block
                  </v-btn>
                </v-col>
              </v-row>
              <v-toolbar flat>
                <v-btn :to="'/admin/preview/' + section + '/' + (index + 1)" text>
                  <v-icon left>fal fa-eye</v-icon>
                  Preview
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="index === 0" text @click="moveSlide(index, -1)">
                  <v-icon left>fal fa-arrow-up</v-icon>
                  Move Up
                </v-btn>
                <v-btn :disabled="index === slides.length - 1" text @click="moveSlide(index, 1)">
                  <v-icon left>fal fa-arrow-down</v-icon>
                  Move Down
                </v-btn>
                <v-btn text color="error" @click="removeSlide(index)">
                  <v-icon left>fal fa-times-circle</v-icon>
                  Remove Slide
                </v-btn>
              </v-toolbar>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn color="success" @click="addSlide">
          <v-icon left>fal fa-plus</v-icon>
          Add Slide
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { inArray } from '../../helpers/has'
import { ref, computed, watch, onMounted, onBeforeUnmount } from '@vue/composition-api'

export default {
  components: {
    contentEditor: () => import('@/components/admin/contentEditor')
  },
  setup (props, { root }) {
    const service = root.$feathers.service('orientation/section')
    const section = computed(() => root.$route.params.section)
    const term = computed(() => root.$store.state.admin.term)
    const termLabel = computed(() => root.$store.state.admin.termLabel)
    const label = ref('')
    const sectionId = ref('')
    const slides = ref([])

    const addDialogActive = ref(false)
    const activeSlide = ref(0)

    const user = computed(() => root.$store.state.user)
    const isAdmin = computed(() => root.$store.getters.isAdmin)

    const onPatchedListener = (data) => {
      if (sectionId.value === data._id) {
        loadSection(data)
      }
    }

    onMounted(() => {
      if (!root.$store.getters.hasRole('Employee')) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the admin system.' })
        root.$router.push('/')
        return
      }
      service.on('patched', onPatchedListener)
    })
    onBeforeUnmount(() => { service.removeListener('patched', onPatchedListener) })

    watch([section, term], () => {
      if (section.value != null && term.value !== '' && term.value != null) {
        service.find({ query: { term: term.value, code: section.value } }).then(({ data }) => {
          if (data.length === 0) {
            root.$router.replace('/admin')
            root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'The section you attempted to access does not exist.' })
            return
          }
          sectionId.value = data[0]._id
          slides.value = []
          loadSection()
        })
      }
    })

    function loadSection (data) {
      if (data != null) {
        label.value = data.label
        slides.value = data.slides
        if (!isAdmin.value && !inArray(user.value.username, data.editors)) {
          root.$router.replace('/admin')
          root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have edit permission for the slide you attempted to access.' })
          return
        }
        if (activeSlide.value == null) activeSlide.value = 0
        if (activeSlide.value >= slides.value.length) activeSlide.value = 0
      } else if (sectionId.value !== '') {
        service.get(sectionId.value).then((data) => { loadSection(data) })
      }
    }

    function blockIcon (type) {
      switch (type) {
        case 'TextCard':
          return 'fal fa-comment-alt-lines'
        case 'ImageCard':
          return 'fal fa-image'
        case 'VideoCard':
          return 'fal fa-film'
        case 'QuizCard':
          return 'fal fa-question-square'
        case 'Carousel':
          return 'fal fa-images'
        case 'Agreement':
          return 'fal fa-check-circle'
        case 'Popups':
          return 'fal fa-stream'
        case 'Timeline':
          return 'fal fa-align-left'
      }
    }

    function updateSlide (slideIndex, name) {
      service.get(sectionId.value).then((data) => {
        if (slideIndex in data.slides) {
          // We are just updating something with the current slide (initially just the name)
          service.patch(sectionId.value, { ['slides.' + slideIndex + '.name']: name }).then(() => {
            root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 3000, text: 'Update Successful' })
          }).catch((err) => {
            root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 10000, text: 'Error saving changes: ' + err })
          })
        }
      })
    }

    function moveSlide (index, dir) {
      let temp = slides.value.splice(index, 1)
      slides.value.splice(index + dir, 0, temp[0])
      activeSlide.value += dir
      service.patch(sectionId.value, { slides: slides.value })
    }

    function removeSlide (index) {
      if (confirm('Are you sure you want to remove this slide?')) {
        slides.value.splice(index, 1)
        service.patch(sectionId.value, { slides: slides.value })
      }
    }

    const blockServ = root.$feathers.service('orientation/block')
    function createBlock () {
      return blockServ.create({ section: sectionId.value, slideNum: slides.value.length, active: true, type: 'TextCard' })
    }
    function addSlide () {
      createBlock().then((data) => {
        root.$feathers.service('orientation/section').patch(sectionId.value, { $push: { slides: { primary: [{ type: data.type, id: data._id }], secondary: [] } } }).then((data) => {
          loadSection(data)
        })
      })
    }

    function addBlock (slideIndex, column) {
      createBlock().then((data) => {
        root.$feathers.service('orientation/section').patch(sectionId.value, { $push: { ['slides.' + slideIndex + '.' + column]: { type: data.type, id: data._id } } }).then((data) => {
          loadSection(data)
        })
      })
    }

    function updateBlock (slideIndex, col, blockIndex, blockData) {
      if (slideIndex in slides.value && col in slides.value[slideIndex] && blockIndex in slides.value[slideIndex][col] && (slides.value[slideIndex][col][blockIndex].type !== blockData.type || slides.value[slideIndex][col][blockIndex].name !== blockData.name)) {
        let temp = JSON.parse(JSON.stringify(slides.value[slideIndex]))
        let changed = false
        if (temp[col][blockIndex].type !== blockData.type) {
          temp[col][blockIndex].type = blockData.type
          changed = true
        }
        if (temp[col][blockIndex].name !== blockData.name) {
          temp[col][blockIndex].name = blockData.name
          changed = true
        }
        if (changed) {
          slides.value.splice(slideIndex, temp)
          service.get(sectionId.value).then((data) => {
            if (slideIndex in data.slides && col in data.slides[slideIndex] && blockIndex in data.slides[slideIndex][col]) {
              let key = ['slides', slideIndex, col, blockIndex]
              service.patch(sectionId.value, { [key.join('.') + '.type']: blockData.type, [key.join('.') + '.name']: blockData.name }).then((data) => loadSection(data))
            }
          })
        }
      }
    }

    function removeBlock (slideIndex, col, blockIndex) {
      let temp = JSON.parse(JSON.stringify(slides.value[slideIndex][col]))
      let id = temp.splice(blockIndex, 1)
      root.$feathers.service('orientation/section').patch(sectionId.value, { ['slides.' + slideIndex + '.' + col]: temp }).then((data) => loadSection(data))
      root.$feathers.service('orientation/block').patch(id[0].id, { active: false })
    }
    function moveBlock (slideIndex, col, blockIndex, dir) {
      let temp = JSON.parse(JSON.stringify(slides.value[slideIndex][col]))
      let item = temp.splice(blockIndex, 1)
      temp.splice(blockIndex + dir, 0, item[0])
      root.$feathers.service('orientation/section').patch(sectionId.value, { ['slides.' + slideIndex + '.' + col]: temp }).then((data) => loadSection(data))
    }
    function changeColumns (slideIndex, col, blockIndex) {
      let temp = JSON.parse(JSON.stringify(slides.value[slideIndex]))
      let item = temp[col].splice(blockIndex, 1)
      if (col === 'primary') temp.secondary.push(item[0])
      else temp.primary.push(item[0])
      root.$feathers.service('orientation/section').patch(sectionId.value, { ['slides.' + slideIndex + '.primary']: temp.primary, ['slides.' + slideIndex + '.secondary']: temp.secondary }).then((data) => loadSection(data))
    }

    const sectionList = ref([])
    watch(term, () => {
      root.$feathers.service('orientation/section').find({ query: { term: term.value, $limit: 20, $sort: { order: 1 } } }).then(({ data }) => {
        sectionList.value = data
      })
    })

    return {
      section,
      term,
      termLabel,
      label,
      sectionId,
      slides,
      addDialogActive,
      activeSlide,
      user,
      isAdmin,
      blockIcon,
      addSlide,
      updateSlide,
      moveSlide,
      removeSlide,
      addBlock,
      updateBlock,
      removeBlock,
      moveBlock,
      changeColumns,
      sectionList,
      inArray
    }
  }
}
</script>
